'use client'

import { useState, useEffect } from 'react'
import { LoadingWheel } from '@/components/Spinner'

// Renders the subflow once mounted in the browser, so it reads the country of the domain from its first render
export default function BrowserOnly({
  children
}: {
  children: React.ReactNode
}) {
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    setLoading(false)
  }, [])

  return loading ? <LoadingWheel /> : children
}
